import React from 'react';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const MePosSaleTitle = () => {
  const { t } = useTranslation();
  return (
    <Col xs={10} >
      <h2 className='fw-normal mb-0 gap-1 text-dark'>
        {t('salesStatistics.Sales Statistics')}
      </h2>
      <div className="d-flex gap-2 text-info">
        <div>{t('salesStatistics.Warehouse accounting')}</div>
        <div><span>></span></div>
        <div>{t('salesStatistics.Sales Statistics')}</div>
      </div>
    </Col>
  );
};

export default MePosSaleTitle;